import { useApi } from "shared/services/api/useApi";

export const useRetainers = () => {
    const { getDataAsync } = useApi();

    const getRetainersFilters = async (clientfamiliesIds, clientIds) => {
        const params = {
            clientFamilies: clientfamiliesIds,
            clientIds: clientIds,
        };
        const payload = await getDataAsync("retainersFilters", { params: params });
        return payload.json();
    };

    const getRetainersFiltersByClientFamily = async (clientFamilyId) => {
        const urlParams = [{ name: "$clientFamilyId", value: clientFamilyId }];
        const payload = await getDataAsync("retainersFiltersByClientFamily", {
            urlParams: urlParams,
        });
        return payload.json();
    };

    const getRetainersFiltersByClient = async (clientId) => {
        const urlParams = [{ name: "$clientId", value: clientId }];
        const payload = await getDataAsync("retainersFiltersByClient", {
            urlParams: urlParams,
        });
        return payload.json();
    };

    return {
        getRetainersFilters,
        getRetainersFiltersByClientFamily,
        getRetainersFiltersByClient,
    };
};
